import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Shield, Eye, EyeOff, Clock, MessageCircle, Home, User } from 'lucide-react';
import './ModeratorDashboard.css';

const ModeratorNavbar = ({ onLogout }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [userName, setUserName] = useState('Moderator');
  
  useEffect(() => {
    // Get user info from localStorage
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        setUserName(user.name || user.email || 'Moderator');
      }
    } catch (err) {
      console.error('Error getting user info:', err);
    }
  }, []);
  
  return (
    <header className="moderator-header">
      <div>
        <p className="header-kicker">SafeHer Moderation · Live</p>
        <h1><Shield size={24} /> Moderator Control Room</h1>
        <p className="moderator-welcome"><User size={14} /> Welcome, {userName}</p>
      </div>
      <div className="moderator-tabs">
        <Link 
          to="/moderator/dashboard" 
          className={currentPath === '/moderator/dashboard' ? 'moderator-tab active' : 'moderator-tab'}
        >
          <Eye size={16} /> Reports
        </Link>
        <Link 
          to="/moderator/hidden" 
          className={currentPath === '/moderator/hidden' ? 'moderator-tab active' : 'moderator-tab'}
        >
          <EyeOff size={16} /> Hidden Queue
        </Link>
        <Link 
          to="/moderator/actions" 
          className={currentPath === '/moderator/actions' ? 'moderator-tab active' : 'moderator-tab'}
        >
          <Clock size={16} /> My Actions
        </Link>
        <Link 
          to="/moderator/messages" 
          className={currentPath === '/moderator/messages' ? 'moderator-tab active' : 'moderator-tab'}
        >
          <MessageCircle size={16} /> Messages
        </Link>
      </div>
      <div className="header-actions">
        <button className="ghost-btn" onClick={() => window.location.href = '/dashboard'}>
          <Home size={16} /> Map
        </button>
        <button className="primary-btn" onClick={onLogout}>
          Logout
        </button>
      </div>
    </header>
  );
};

export default ModeratorNavbar;
